import { getField, updateField } from "vuex-map-fields";
import API from "@/api";
import theme from "@/plugins/theme";

const initialState = () => ({
  defaultTheme: null,
  customTheme: null,
  selectedTheme: null, // Azul
  theme: theme,
});

export const state = initialState();

export const getters = {
  getField,
  defaultTheme(state) {
    return state.defaultTheme;
  },
};

export const actions = {
  async getDefaultTheme({ commit }) {
    let res = await API.axios.get("/bff/api/v1/static/assets/theme.json");

    if (res.status === 200) {
      commit("updateField", { path: "defaultTheme", value: res.data });
      commit("updateField", { path: "selectedTheme", value: res.data });
    }
  },
  async saveSelectedTheme({ state, commit }, theme) {
    const response = await API.axios.post("/bff/api/v1/theme", theme);
    if (response.status === 200) {
      commit("updateField", {
        path: "defaultTheme",
        value: state.selectedTheme,
      });
    }
    return response;
  },
  setDefaultTheme({ commit }, theme) {
    commit("updateField", { path: "defaultTheme", value: theme });
    commit("updateField", { path: "selectedTheme", value: theme });
  },
  // eslint-disable-next-line no-unused-vars
  setInitialTheme({ state }, { theme, vuetify }) {
    if (theme) {
      if (!theme.light || !theme.dark) {
        return;
      }
      Object.assign(vuetify.theme.themes.light, theme.light);
      Object.assign(vuetify.theme.themes.dark, theme.dark);

      vuetify.theme.options.headingImg = theme.headingImg;
    } else {
      console.log("failed in setInitialTheme");
    }
  },

  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
